import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import './style.css';

const CookieConsent = () => {
  const [cookieConsent, setCookieConsent] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("cookieConsent");
    if (consent) {
      setCookieConsent(true);
    }
  }, []);

  const handleCookie = () => {
    Cookies.set("cookieConsent", "true", { expires: 365 });
    setCookieConsent(true);
  };

  const handleDecline = () => {
    Cookies.set("cookieConsent", "declined", { expires: 365 });
    setCookieConsent(true); // Just hide the banner
  };

  if (cookieConsent) {
    return null;
  }

  return (
    <div>
      <div className="container fixed-bottom">
        <div className="w-100 d-flex justify-content-center">
          <div className="strip rounded-4 mb-3 py-3 shadow">
            <div className="d-flex flex-column flex-lg-row 
              justify-content-center justify-content-lg-between 
              align-items-center h-100 px-4">
              <div className="fs-6 col-12 col-lg-7 pb-4 pb-lg-2 text-start">
                We use cookies to improve user experience and analyze website traffic. By clicking “Accept“, you agree to our website's cookie use as described in our <a href="/legal/privacy">Privacy Policy</a>.</div>
              <div className="d-flex flex-row">
                <div className="pe-2">
                  <button className="btn btn-dark decline-btn"
                    onClick={handleDecline}>
                    Decline
                  </button>
                </div>
                <div className="ps-2">
                  <button className="btn btn-dark accept-btn" 
                    onClick={handleCookie}>
                    Accept All
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;